module.exports = __webpack_public_path__ + "img/Crop_logo_allstech.0993717c.svg";